import $ from 'jquery';

$(document).ready(function() {
  $("#search, .search").on('change', '.search-autosubmit', function() {
    // var nativeFormElement = $(this).closest('form')[0];
    // Rails.fire(nativeFormElement, 'submit');
    $(this).closest('form').submit();
  });
});
